import { render } from "./Profesionales.vue?vue&type=template&id=0a80cec4&ts=true"
import script from "./Profesionales.vue?vue&type=script&lang=ts"
export * from "./Profesionales.vue?vue&type=script&lang=ts"

import "./Profesionales.vue?vue&type=style&index=0&id=0a80cec4&lang=scss"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__